import PropTypes from "prop-types";

// material-ui
import { useTheme } from "@mui/material/styles";
import { Avatar, Box, ButtonBase } from "@mui/material";

// project imports
import LogoSection from "./LogoSection";
import ProfileSection from "./ProfilePage";
import NotificationSection from "./NotificationSection";
import StockReel from "./StockReel";
// assets
import { IconMenu2 } from "@tabler/icons";

// ==============================|| MAIN NAVBAR / HEADER ||============================== //

const Header = ({ handleLeftDrawerToggle }) => {
    const theme = useTheme();

    return (
        <>
            {/* logo & toggler button */}
            <Box
                sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    width: "100%",
                    [theme.breakpoints.up("md")]: {
                        width: 228,
                    },
                }}
            >
                {/* LogoSection */}
                <Box sx={{ flexGrow: 1, display: { xs: "none", md: "block" } }}>
                    <LogoSection />
                </Box>

                {/* Toggler Button */}
                <ButtonBase sx={{ borderRadius: "12px", overflow: "hidden" }}>
                    {/* Avatar */}
                    <Avatar
                        variant="rounded"
                        sx={{
                            ...theme.typography.commonAvatar,
                            ...theme.typography.mediumAvatar,
                            transition: "all .2s ease-in-out",
                            background: theme.palette.secondary.light,
                            color: theme.palette.secondary.dark,
                            "&:hover": {
                                background: theme.palette.secondary.dark,
                                color: theme.palette.secondary.light,
                            },
                        }}
                        onClick={handleLeftDrawerToggle}
                        color="inherit"
                    >
                        <IconMenu2 stroke={1.5} size="21px" />
                    </Avatar>
                </ButtonBase>
            </Box>

            {/* StockReel */}
            <Box sx={{ flexGrow: 1, pl: 2 }}>
                <StockReel />
            </Box>

            {/* notification & profile */}
            <NotificationSection />
            <ProfileSection />
        </>
    );
};

Header.propTypes = {
    handleLeftDrawerToggle: PropTypes.func,
};

export default Header;
